import { createDataModuleActions } from '@perpay-web/data-module/createDataModuleActions';

const validateMFACodeActions = createDataModuleActions('VALIDATE_MFA_CODE');
export const validateMFACode = validateMFACodeActions.dataRequest;
export const validateMFACodeSuccess = validateMFACodeActions.dataSuccess;
export const validateMFACodeError = validateMFACodeActions.dataError;
